export const INIT_PLAYER_DATA = 'INIT_PLAYER_DATA';

export const CLEAR_OLD_PLAYER_DATA = 'CLEAR_OLD_PLAYER_DATA';

export const SET_SPEED = 'SET_SPEED';

export const SET_POP_MENU_SHOW = 'SET_POP_MENU_SHOW';

export const SET_POP_MARKER_SHOW = 'SET_POP_MARKER_SHOW';
